import { render } from "./colour-selector-drawer.vue?vue&type=template&id=215d0c32"
import script from "./colour-selector-drawer.vue?vue&type=script&lang=js"
export * from "./colour-selector-drawer.vue?vue&type=script&lang=js"

import "./colour-selector-drawer.vue?vue&type=style&index=0&id=215d0c32&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__